// 共通処理
export function common() {
  // ヘッダーのスクロール制御
  const header = document.getElementById("js-header");
  if (!header) return;

  window.addEventListener("scroll", () => {
    // PC幅かつスクロール時にクラス付与
    if (window.scrollY > 1 && window.innerWidth > 768) {
      header.classList.add("is-scroll");
    } else {
      header.classList.remove("is-scroll");
    }
  });

  // c-mvが画面から消えたら_topクラスを削除（トップページのみ）
  const isFrontPage = document.body.classList.contains("home") || window.location.pathname === "/" || window.location.pathname === "";
  const mv = document.querySelector(".c-mv");
  
  if (isFrontPage && mv && header) {
    // Intersection Observerでc-mvの表示状態を監視
    const mvObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // c-mvが画面にある場合は_topクラスを追加
            header.classList.add("_top");
          } else {
            // c-mvが画面から消えた場合は_topクラスを削除
            header.classList.remove("_top");
          }
        });
      },
      {
        rootMargin: "0px",
        threshold: 0,
      }
    );

    mvObserver.observe(mv);
  }

  // c-mv02の表示状態に応じてc-fixの表示/非表示を制御（新車リースページのみ）
  const isNewCarLeasePage = window.location.pathname.includes('new-car-lease');
  const mv02 = document.querySelector(".c-mv02");
  const fix = document.querySelector(".c-fix");
  
  if (isNewCarLeasePage && mv02 && fix) {
    // 初期状態では非表示にする（c-mv02が画面にあるため）
    fix.classList.add("is-hidden");

    // Intersection Observerでc-mv02の表示状態を監視
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // c-mv02が画面にある場合はc-fixを非表示
            fix.classList.add("is-hidden");
            fix.classList.remove("is-visible");
          } else {
            // c-mv02が画面から消えた場合はc-fixを表示
            fix.classList.remove("is-hidden");
            fix.classList.add("is-visible");
          }
        });
      },
      {
        // 少し余裕を持たせて判定（c-mv02が完全に消える前に表示）
        rootMargin: "0px",
        threshold: 0,
      }
    );

    observer.observe(mv02);
  }

  // p-interview-mvの表示状態に応じてc-fixの表示/非表示を制御（インタビューページ）
  const isInterviewPage = document.body.classList.contains(
    "page-template-page-interview-php"
  );
  const interviewMv = document.querySelector(".p-interview-mv");

  if (isInterviewPage && interviewMv && fix) {
    fix.classList.add("is-hidden");

    const interviewObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            fix.classList.add("is-hidden");
            fix.classList.remove("is-visible");
          } else {
            fix.classList.remove("is-hidden");
            fix.classList.add("is-visible");
          }
        });
      },
      {
        rootMargin: "0px",
        threshold: 0,
      }
    );

    interviewObserver.observe(interviewMv);
  }
}